export default __webpack_public_path__ + "static/media/1.6e898f0e.jpg";